import * as React from "react";
import { IconMinus, IconPlus } from "@tabler/icons-react";
import "./quantity-stepper.css";

export function QuantityStepper({ value, min = 0, max, onChange, disabled, label, presets = true }) {
  const [draft, setDraft] = React.useState(null);
  const [pulse, setPulse] = React.useState(0);
  const current = React.useRef({ value, min, max, disabled, onChange });
  const hold = React.useRef(null);
  current.current = { value, min, max, disabled, onChange };
  const stop = React.useCallback(() => { clearTimeout(hold.current); hold.current = null; }, []);
  React.useEffect(() => {
    const blur = () => stop();
    window.addEventListener("blur", blur);
    document.addEventListener("visibilitychange", blur);
    return () => { stop(); window.removeEventListener("blur", blur); document.removeEventListener("visibilitychange", blur); };
  }, [stop]);
  React.useEffect(() => { if (disabled) stop(); }, [disabled, stop]);
  function update(next) {
    const state = current.current;
    if (state.disabled) return false;
    const number = Math.max(state.min, Math.min(state.max, Math.trunc(next)));
    if (number === state.value) return false;
    state.value = number;
    setDraft(null); setPulse(n => n + 1); state.onChange(number);
    return true;
  }
  function start(event, direction) {
    if (event.button !== 0) return;
    event.preventDefault(); stop();
    event.currentTarget.setPointerCapture(event.pointerId);
    update(current.current.value + direction);
    const repeat = () => { if (update(current.current.value + direction)) hold.current = setTimeout(repeat, 100); };
    hold.current = setTimeout(repeat, 400);
  }
  return <div className="kh-quantity" role="group" aria-label={label}>
    <div className="kh-quantity__control">
      {[-1, 1].map(direction => <React.Fragment key={direction}>
        {direction === 1 && <input className={`kh-quantity__value ${pulse % 2 ? "is-changing" : ""}`} type="text" inputMode="numeric" role="spinbutton" aria-label={label} aria-valuemin={min} aria-valuemax={max} aria-valuenow={value} disabled={disabled} value={draft ?? value} onChange={event => { const raw = event.target.value; if (raw === "") { setDraft(""); return; } if (/^\d+$/.test(raw)) { update(Number(raw)); setDraft(null); } }} onBlur={() => setDraft(null)} onKeyDown={event => { if (event.key === "ArrowUp" || event.key === "ArrowDown") { event.preventDefault(); update(value + (event.key === "ArrowUp" ? 1 : -1)); } }} />}
        <button type="button" aria-label={`${direction < 0 ? "Уменьшить" : "Увеличить"}: ${label}`} disabled={disabled || (direction < 0 ? value <= min : value >= max)} onPointerDown={event => start(event, direction)} onPointerUp={stop} onPointerCancel={stop} onLostPointerCapture={stop} onClick={event => { if (event.detail === 0) update(current.current.value + direction); }}>{direction < 0 ? <IconMinus size={19} /> : <IconPlus size={19} />}</button>
      </React.Fragment>)}
    </div>
    {presets && <div className="kh-quantity__presets">{[...new Set([Math.min(max, Math.max(min, 5)), Math.min(max, Math.max(min, 10)), max])].map(number => <button type="button" key={number} disabled={disabled} aria-label={`${label}: выбрать ${number}`} aria-pressed={value === number} onClick={() => update(number)}>{number === max ? "Макс." : number}</button>)}</div>}
  </div>;
}
